import axios from 'axios';
let latestProductRequest = 0;

export default {
  state: {
    product: {},
    productError: null,
    productLoaded: false,
    productLoading: false,
    noMoreProduct: false
  },
  mutations: {
    SET_PRODUCT(state, product) {
      state.product = product;
      state.productLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PRODUCT_LOADING(state, status) {
      state.productLoading = status;
    },
    UNSET_PRODUCT(state) {
      state.productLoaded = false;
      state.productLoading = false;
      state.product = {};
    },
    SET_PRODUCT_ERROR(state, error) {
      state.productError = error;
    }
  },
  actions: {
    async fetchProduct({ commit, state }, id) {
      const request = ++latestProductRequest;
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_PRODUCT_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/detail/'+id+'/');

        if (request !== latestProductRequest) { return; }
        if (response.data.status == 'success') {
          commit('SET_PRODUCT', response.data.data);
          commit('SET_PRODUCT_ERROR', null);
        }
        else {
          commit('UNSET_PRODUCT');
          let serverError= '';
          for (let i in response.data.errors) {
            serverError += response.data.errors[i].message+"<br>";
          }
          commit('SET_PRODUCT_ERROR', serverError);
        }


      } catch (error) {
        if (request !== latestProductRequest) { return; }
        commit('SET_PRODUCT_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        if (request === latestProductRequest) { commit('SET_PRODUCT_LOADING', false); }
      }
    }
  },
  getters: {
    product: state => state.product,
    productLoading: state => state.productLoading,
    productError: state => state.productError,
    productLoaded: state => state.productLoaded
  }
}